import { render, staticRenderFns } from "./HolderNewButton.vue?vue&type=template&id=00a85205&scoped=true&"
import script from "./HolderNewButton.vue?vue&type=script&lang=ts&"
export * from "./HolderNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./HolderNewButton.vue?vue&type=style&index=0&id=00a85205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a85205",
  null
  
)

export default component.exports